import { gql, useQuery } from '@apollo/client';

import { Invoice } from '@work4all/models/lib/Classes/Invoice.entity';

const QUERY = gql`
  query GetOpenPartialInvoices($sdObjMemberCode: Int!) {
    getOpenPartialInvoices(sdObjMemberCode: $sdObjMemberCode) {
      id: code
      number: nummer
      date: datum
      note: notiz
      value: wert
      grossValue: bruttowert
      project: projekt {
        id: code
        name: name
        number: nummer
        __typename
      }
      __typename
    }
  }
`;

type Variables = {
  sdObjMemberCode: number;
};

type Response = {
  getOpenPartialInvoices: Invoice[];
};

export const useOpenPartialInvoices = (sdObjMemberCode: number) => {
  const response = useQuery<Response, Variables>(QUERY, {
    variables: { sdObjMemberCode },
  });

  return response?.data?.getOpenPartialInvoices ?? [];
};
